export const KUBERNETES = {
  KUBERNETES_POD_DETAIL_DASHBOARD_SETTING_LIST: 'KUBERNETES_POD_DETAIL_DASHBOARD_SETTING_LIST',
  KUBERNETES_NAMESPACE_DETAIL_DASHBOARD_SETTING_LIST:
    'KUBERNETES_NAMESPACE_DETAIL_DASHBOARD_SETTING_LIST',
  KUBERNETES_CLUSTER_TARGETS: 'KUBERNETES_CLUSTER_TARGETS',

  KUBERNETES_NODE_DETAIL_DASHBOARD_SETTING_LIST: 'KUBERNETES_NODE_DETAIL_DASHBOARD_SETTING_LIST',

  KUBERNETES_DEPLOYMENT_DETAIL_DASHBOARD_SETTING_LIST:
    'KUBERNETES_DEPLOYMENT_DETAIL_DASHBOARD_SETTING_LIST',
  KUBERNETES_STATEFULSET_DETAIL_DASHBOARD_SETTING_LIST:
    'KUBERNETES_STATEFULSET_DETAIL_DASHBOARD_SETTING_LIST',
  KUBERNETES_DAEMONSET_DETAIL_DASHBOARD_SETTING_LIST:
    'KUBERNETES_DAEMONSET_DETAIL_DASHBOARD_SETTING_LIST',
  KUBERNETES_REPLICASET_DETAIL_DASHBOARD_SETTING_LIST:
    'KUBERNETES_REPLICASET_DETAIL_DASHBOARD_SETTING_LIST',

  KUBERNETES_HPA_DETAIL_DASHBOARD_SETTING_LIST: 'KUBERNETES_HPA_DETAIL_DASHBOARD_SETTING_LIST',
  KUBERNETES_JOB_DETAIL_DASHBOARD_SETTING_LIST: 'KUBERNETES_JOB_DETAIL_DASHBOARD_SETTING_LIST',
  KUBERNETES_CRONJOB_DETAIL_DASHBOARD_SETTING_LIST:
    'KUBERNETES_CRONJOB_DETAIL_DASHBOARD_SETTING_LIST',

  KUBERNETES_SERVICE_DETAIL_DASHBOARD_SETTING_LIST:
    'KUBERNETES_SERVICE_DETAIL_DASHBOARD_SETTING_LIST',
  KUBERNETES_INGRESS_DETAIL_DASHBOARD_SETTING_LIST:
    'KUBERNETES_INGRESS_DETAIL_DASHBOARD_SETTING_LIST',
  KUBERNETES_OPENSHIFT_ROUTE_DETAIL_DASHBOARD_SETTING_LIST:
    'KUBERNETES_OPENSHIFT_ROUTE_DETAIL_DASHBOARD_SETTING_LIST',
  KUBERNETES_VIRTUAL_SERVICE_DETAIL_DASHBOARD_SETTING_LIST:
    'KUBERNETES_VIRTUAL_SERVICE_DETAIL_DASHBOARD_SETTING_LIST',

  KUBERNETES_CONFIG_MAP_DETAIL_DASHBOARD_SETTING_LIST:
    'KUBERNETES_CONFIG_MAP_DETAIL_DASHBOARD_SETTING_LIST',
  KUBERNETES_PVC_DETAIL_DASHBOARD_SETTING_LIST: 'KUBERNETES_PVC_DETAIL_DASHBOARD_SETTING_LIST',
  KUBERNETES_PV_DETAIL_DASHBOARD_SETTING_LIST: 'KUBERNETES_PV_DETAIL_DASHBOARD_SETTING_LIST',
  KUBERNETES_STORAGE_CLASS_DETAIL_DASHBOARD_SETTING_LIST:
    'KUBERNETES_STORAGE_CLASS_DETAIL_DASHBOARD_SETTING_LIST',

  KUBERNETES_ROLE_DETAIL_DASHBOARD_SETTING_LIST: 'KUBERNETES_ROLE_DETAIL_DASHBOARD_SETTING_LIST',
  KUBERNETES_ROLE_BINDING_DETAIL_DASHBOARD_SETTING_LIST:
    'KUBERNETES_ROLE_BINDING_DETAIL_DASHBOARD_SETTING_LIST',

  KUBERNETES_CLUSTER_ROLE_DETAIL_DASHBOARD_SETTING_LIST:
    'KUBERNETES_CLUSTER_ROLE_DETAIL_DASHBOARD_SETTING_LIST',
  KUBERNETES_CLUSTER_ROLE_BINDING_DETAIL_DASHBOARD_SETTING_LIST:
    'KUBERNETES_CLUSTER_ROLE_BINDING_DETAIL_DASHBOARD_SETTING_LIST',
  KUBERNETES_SERVICE_ACCOUNT_DETAIL_DASHBOARD_SETTING_LIST:
    'KUBERNETES_SERVICE_ACCOUNT_DETAIL_DASHBOARD_SETTING_LIST',

  GRIDCOLUMNS_kubernetes_pod_podList: 'GRIDCOLUMNS_kubernetes_pod_podList',
  GRIDCOLUMNS_kubernetes_podsListDetail_containers:
    'GRIDCOLUMNS_kubernetes_podsListDetail_containers',
  GRIDCOLUMNS_kubernetes_podsListDetail_pvc: 'GRIDCOLUMNS_kubernetes_podsListDetail_pvc',
  GRIDCOLUMNS_kubernetes_container_containerList: 'GRIDCOLUMNS_kubernetes_container_containerList',
  GRIDCOLUMNS_kubernetes_namespace_namespaceList: 'GRIDCOLUMNS_kubernetes_namespace_namespaceList',
  GRIDCOLUMNS_kubernetes_node_nodeList: 'GRIDCOLUMNS_kubernetes_node_nodeList',
  GRIDCOLUMNS_kubernetes_nodeDetail_podList: 'GRIDCOLUMNS_kubernetes_nodeDetail_podList',
  GRIDCOLUMNS_kubernetes_nodeDetail_process_processList:
    'GRIDCOLUMNS_kubernetes_nodeDetail_process_processList',
  GRIDCOLUMNS_kubernetes_nodeDetail_diskList: 'GRIDCOLUMNS_kubernetes_nodeDetail_diskList',
  GRIDCOLUMNS_kubernetes_nodeDetail_imageList: 'GRIDCOLUMNS_kubernetes_nodeDetail_imageList',
  GRIDCOLUMNS_kubernetes_nodeDetail_gpuList: 'GRIDCOLUMNS_kubernetes_nodeDetail_gpuList',
  GRIDCOLUMNS_kubernetes_workloads_deploymentsList:
    'GRIDCOLUMNS_kubernetes_workloads_deploymentsList',
  GRIDCOLUMNS_kubernetes_workloads_stateFulSetsList:
    'GRIDCOLUMNS_kubernetes_workloads_stateFulSetsList',
  GRIDCOLUMNS_kubernetes_workloads_daemonSetsList:
    'GRIDCOLUMNS_kubernetes_workloads_daemonSetsList',
  GRIDCOLUMNS_kubernetes_workloads_replicaSetsList:
    'GRIDCOLUMNS_kubernetes_workloads_replicaSetsList',
  GRIDCOLUMNS_kubernetes_deploymentsDetail_podList:
    'GRIDCOLUMNS_kubernetes_deploymentsDetail_podList',
  GRIDCOLUMNS_kubernetes_statefulSetsDetail_podList:
    'GRIDCOLUMNS_kubernetes_statefulSetsDetail_podList',
  GRIDCOLUMNS_kubernetes_daemonSetsDetail_podList:
    'GRIDCOLUMNS_kubernetes_daemonSetsDetail_podList',
  GRIDCOLUMNS_kubernetes_replicaSetsDetail_podList:
    'GRIDCOLUMNS_kubernetes_replicaSetsDetail_podList',
  GRIDCOLUMNS_kubernetes_hpa_hpaList: 'GRIDCOLUMNS_kubernetes_hpa_hpaList',
  GRIDCOLUMNS_kubernetes_hpaDetail_podList: 'GRIDCOLUMNS_kubernetes_hpaDetail_podList',
  GRIDCOLUMNS_kubernetes_jobs_jobList: 'GRIDCOLUMNS_kubernetes_jobs_jobList',
  GRIDCOLUMNS_kubernetes_jobsDetail_podList: 'GRIDCOLUMNS_kubernetes_jobsDetail_podList',
  GRIDCOLUMNS_kubernetes_cronJobs_cronJobList: 'GRIDCOLUMNS_kubernetes_cronJobs_cronJobList',
  GRIDCOLUMNS_kubernetes_cronJobsDetail_jobList: 'GRIDCOLUMNS_kubernetes_cronJobsDetail_jobList',
  GRIDCOLUMNS_kubernetes_cronJobsDetail_podList: 'GRIDCOLUMNS_kubernetes_cronJobsDetail_podList',
  GRIDCOLUMNS_kubernetes_service_serviceList: 'GRIDCOLUMNS_kubernetes_service_serviceList',
  GRIDCOLUMNS_kubernetes_serviceDetail_portList: 'GRIDCOLUMNS_kubernetes_serviceDetail_portList',
  GRIDCOLUMNS_kubernetes_serviceDetail_podList: 'GRIDCOLUMNS_kubernetes_serviceDetail_podList',
  GRIDCOLUMNS_kubernetes_serviceDetail_endpointList:
    'GRIDCOLUMNS_kubernetes_serviceDetail_endpointList',
  GRIDCOLUMNS_kubernetes_ingress_ingressTreeGrid: 'GRIDCOLUMNS_kubernetes_ingress_ingressTreeGrid',
  GRIDCOLUMNS_kubernetes_ingressController_ingressControllerList:
    'GRIDCOLUMNS_kubernetes_ingressController_ingressControllerList',
  GRIDCOLUMNS_kubernetes_openshiftRoute_routeList:
    'GRIDCOLUMNS_kubernetes_openshiftRoute_routeList',
  GRIDCOLUMNS_kubernetes_ingressDetail_rulesList: 'GRIDCOLUMNS_kubernetes_ingressDetail_rulesList',
  GRIDCOLUMNS_kubernetes_openshiftRouteDetail_rulesList:
    'GRIDCOLUMNS_kubernetes_openshiftRouteDetail_rulesList',
  GRIDCOLUMNS_kubernetes_virtualServiceDetail_routeList:
    'GRIDCOLUMNS_kubernetes_virtualServiceDetail_routeList',
  GRIDCOLUMNS_kubernetes_virtualServiceDetail_eventList:
    'GRIDCOLUMNS_kubernetes_virtualServiceDetail_eventList',
  GRIDCOLUMNS_kubernetes_ingressDetail_loadBalancerList:
    'GRIDCOLUMNS_kubernetes_ingressDetail_loadBalancerList',
  GRIDCOLUMNS_kubernetes_ingressControllerDetail_ingressList:
    'GRIDCOLUMNS_kubernetes_ingressControllerDetail_ingressList',
  GRIDCOLUMNS_kubernetes_configMaps_configMapsList:
    'GRIDCOLUMNS_kubernetes_configMaps_configMapsList',
  GRIDCOLUMNS_kubernetes_persistentVolumeClaim_persistentVolumeClaimList:
    'GRIDCOLUMNS_kubernetes_persistentVolumeClaim_persistentVolumeClaimList',
  GRIDCOLUMNS_kubernetes_persistentVolumeClaimDetail_podList:
    'GRIDCOLUMNS_kubernetes_persistentVolumeClaimDetail_podList',
  GRIDCOLUMNS_kubernetes_persistentVolume_persistentVolumeList:
    'GRIDCOLUMNS_kubernetes_persistentVolume_persistentVolumeList',
  GRIDCOLUMNS_kubernetes_storageClasses_storageClassesList:
    'GRIDCOLUMNS_kubernetes_storageClasses_storageClassesList',
  GRIDCOLUMNS_kubernetes_storageClassesDetail_persistentVolumesList:
    'GRIDCOLUMNS_kubernetes_storageClassesDetail_persistentVolumesList',
  GRIDCOLUMNS_kubernetes_roles_rolesList: 'GRIDCOLUMNS_kubernetes_roles_rolesList',
  GRIDCOLUMNS_kubernetes_rolesBindings_rolesBindingsList:
    'GRIDCOLUMNS_kubernetes_rolesBindings_rolesBindingsList',
  GRIDCOLUMNS_kubernetes_clusterRoles_clusterRolesList:
    'GRIDCOLUMNS_kubernetes_clusterRoles_clusterRolesList',
  GRIDCOLUMNS_kubernetes_clusterRolesBindings_clusterRolesBindingsList:
    'GRIDCOLUMNS_kubernetes_clusterRolesBindings_clusterRolesBindingsList',
  GRIDCOLUMNS_kubernetes_clusterRolesBindingsDetail_referenceList:
    'GRIDCOLUMNS_kubernetes_clusterRolesBindingsDetail_referenceList',
  GRIDCOLUMNS_kubernetes_clusterRolesBindingsDetail_bindingsList:
    'GRIDCOLUMNS_kubernetes_clusterRolesBindingsDetail_bindingsList',
  GRIDCOLUMNS_kubernetes_serviceAccounts_serviceAccountsList:
    'GRIDCOLUMNS_kubernetes_serviceAccounts_serviceAccountsList',
  GRIDCOLUMNS_kubernetes_detailEventGrid: 'GRIDCOLUMNS_kubernetes_detailEventGrid',
  GRIDCOLUMNS_kubernetes_top10Stat: 'GRIDCOLUMNS_kubernetes_top10Stat',
  GRIDCOLUMNS_kubernetes_scListDetail_storageClassList:
    'GRIDCOLUMNS_kubernetes_scListDetail_storageClassList',
  GRIDCOLUMNS_kubernetes_clusterResourceInventoryView_nodeList:
    'GRIDCOLUMNS_kubernetes_clusterResourceInventoryView_nodeList',
  GRIDCOLUMNS_kubernetes_clusterResourceInventoryView_containerList:
    'GRIDCOLUMNS_kubernetes_clusterResourceInventoryView_containerList',
  GRIDCOLUMNS_kubernetes_clusterResourceInventoryView_serviceDetail_serviceList:
    'GRIDCOLUMNS_kubernetes_clusterResourceInventoryView_serviceDetail_serviceList',
  GRIDCOLUMNS_kubernetes_clusterResourceInventoryView_ingressDetail_ingressList:
    'GRIDCOLUMNS_kubernetes_clusterResourceInventoryView_ingressDetail_ingressList',
  GRIDCOLUMNS_kubernetes_clusterResourceInventoryView_routeDetail_routeList:
    'GRIDCOLUMNS_kubernetes_clusterResourceInventoryView_routeDetail_routeList',
  GRIDCOLUMNS_kubernetes_clusterResourceInventoryView_virtualServiceDetail_virtualServiceList:
    'GRIDCOLUMNS_kubernetes_clusterResourceInventoryView_virtualServiceDetail_virtualServiceList',

  GRIDSETTINGS_kubernetes_storageOverview_distributionList_storageClass:
    'GRIDSETTINGS_kubernetes_storageOverview_distributionList_storageClass',
  GRIDSETTINGS_kubernetes_storageOverview_distributionList_namespace:
    'GRIDSETTINGS_kubernetes_storageOverview_distributionList_namespace',

  FILTER_kubernetes_objectTopology: 'FILTER_kubernetes_objectTopology',
  FILTER_kubernetes_clusterTopology: 'FILTER_kubernetes_clusterTopology',
  FILTER_kubernetes_cluster: 'FILTER_kubernetes_cluster',
  FILTER_kubernetes_pod: 'FILTER_kubernetes_pod',
  FILTER_kubernetes_container: 'FILTER_kubernetes_container',
  FILTER_kubernetes_namespace: 'FILTER_kubernetes_namespace',
  FILTER_kubernetes_node: 'FILTER_kubernetes_node',

  FILTER_kubernetes_workLoad: 'FILTER_kubernetes_workLoad',

  FILTER_kubernetes_workLoad_hpa: 'FILTER_kubernetes_workLoad_hpa',
  FILTER_kubernetes_workLoad_job: 'FILTER_kubernetes_workLoad_job',
  FILTER_kubernetes_workLoad_cronJob: 'FILTER_kubernetes_workLoad_cronJob',

  FILTER_kubernetes_network_serviceMap: 'FILTER_kubernetes_network_serviceMap',
  FILTER_kubernetes_network_service: 'FILTER_kubernetes_network_service',
  FILTER_kubernetes_network_ingress: 'FILTER_kubernetes_network_ingress',
  FILTER_kubernetes_network_ingress_controller: 'FILTER_kubernetes_network_ingress_controller',
  FILTER_kubernetes_network_openshift_route: 'FILTER_kubernetes_network_openshift_route',
  FILTER_kubernetes_configStorage_configMap: 'FILTER_kubernetes_configStorage_configMap',
  FILTER_kubernetes_configStorage_persistentVolumeClaim:
    'FILTER_kubernetes_configStorage_persistentVolumeClaim',
  FILTER_kubernetes_configStorage_persistentVolume:
    'FILTER_kubernetes_configStorage_persistentVolume',
  FILTER_kubernetes_configStorage_storageClass: 'FILTER_kubernetes_configStorage_storageClass',
  FILTER_kubernetes_storage: 'FILTER_kubernetes_storage',
  FILTER_kubernetes_accessControl_role: 'FILTER_kubernetes_accessControl_role',
  FILTER_kubernetes_accessControl_roleBinding: 'FILTER_kubernetes_accessControl_roleBinding',
  FILTER_kubernetes_accessControl_clusterRole: 'FILTER_kubernetes_accessControl_clusterRole',
  FILTER_kubernetes_accessControl_clusterRoleBinding:
    'FILTER_kubernetes_accessControl_clusterRoleBinding',
  FILTER_kubernetes_accessControl_serviceAccount: 'FILTER_kubernetes_accessControl_serviceAccount',
  FILTERSEARCH_kubernetes_clusterTopology: 'FILTERSEARCH_kubernetes_clusterTopology',
  FILTERSEARCH_kubernetes_objectTopology: 'FILTERSEARCH_kubernetes_objectTopology',
  FILTERSEARCH_kubernetes_podListView_podList: 'FILTERSEARCH_kubernetes_podListView_podList',
  FILTERSEARCH_kubernetes_containerView_containerList:
    'FILTERSEARCH_kubernetes_containerView_containerList',
  FILTERSEARCH_kubernetes_namespaceView_namespaceList:
    'FILTERSEARCH_kubernetes_namespaceView_namespaceList',
  FILTERSEARCH_kubernetes_nodeView_nodeList: 'FILTERSEARCH_kubernetes_nodeView_nodeList',
  FILTERSEARCH_kubernetes_deployment_deploymentList:
    'FILTERSEARCH_kubernetes_deployment_deploymentList',
  FILTERSEARCH_kubernetes_statefulSets_statusSetsList:
    'FILTERSEARCH_kubernetes_statefulSets_statusSetsList',
  FILTERSEARCH_kubernetes_daemonSet_daemonSetList:
    'FILTERSEARCH_kubernetes_daemonSet_daemonSetList',
  FILTERSEARCH_kubernetes_replicaSets_replicaSetsList:
    'FILTERSEARCH_kubernetes_replicaSets_replicaSetsList',
  FILTERSEARCH_kubernetes_hpaView_hpaList: 'FILTERSEARCH_kubernetes_hpaView_hpaList',
  FILTERSEARCH_kubernetes_job_jobList: 'FILTERSEARCH_kubernetes_job_jobList',
  FILTERSEARCH_kubernetes_cronJabs_cronJobsList: 'FILTERSEARCH_kubernetes_cronJabs_cronJobsList',
  FILTERSEARCH_kubernetes_serviceView_serviceList:
    'FILTERSEARCH_kubernetes_serviceView_serviceList',
  FILTERSEARCH_kubernetes_ingressView_ingressList:
    'FILTERSEARCH_kubernetes_ingressView_ingressList',
  FILTERSEARCH_kubernetes_ingressDetail_rulesList:
    'FILTERSEARCH_kubernetes_ingressDetail_rulesList',
  FILTERSEARCH_kubernetes_ingressView_detailIngressList:
    'FILTERSEARCH_kubernetes_ingressView_detailIngressList',
  FILTERSEARCH_kubernetes_ingressControllerView_list:
    'FILTERSEARCH_kubernetes_ingressControllerView_list',
  FILTERSEARCH_kubernetes_openshiftRouteView_routeList:
    'FILTERSEARCH_kubernetes_openshiftRouteView_routeList',
  FILTERSEARCH_kubernetes_openshiftRouteDetail_rulesList:
    'FILTERSEARCH_kubernetes_openshiftRouteDetail_rulesList',
  FILTERSEARCH_kubernetes_configMapView_configMapsList:
    'FILTERSEARCH_kubernetes_configMapView_configMapsList',
  FILTERSEARCH_kubernetes_persistentVolumeClaimView_persistentVolumeClaimList:
    'FILTERSEARCH_kubernetes_persistentVolumeClaimView_persistentVolumeClaimList',
  FILTERSEARCH_kubernetes_persistentVolumeView_persistentVolumeList:
    'FILTERSEARCH_kubernetes_persistentVolumeView_persistentVolumeList',
  FILTERSEARCH_kubernetes_storageClassView_storageClassList:
    'FILTERSEARCH_kubernetes_storageClassView_storageClassList',
  FILTERSEARCH_kubernetes_roleView_roleList: 'FILTERSEARCH_kubernetes_roleView_roleList',
  FILTERSEARCH_kubernetes_roleBinding_roleBindingList:
    'FILTERSEARCH_kubernetes_roleBinding_roleBindingList',
  FILTERSEARCH_kubernetes_clusterRoles_clusterRolesList:
    'FILTERSEARCH_kubernetes_clusterRoles_clusterRolesList',
  FILTERSEARCH_kubernetes_clusterRoleBinding_clusterRolesBindingList:
    'FILTERSEARCH_kubernetes_clusterRoleBinding_clusterRolesBindingList',
  FILTERSEARCH_kubernetes_serviceAccountView_serviceAccountList:
    'FILTERSEARCH_kubernetes_serviceAccountView_serviceAccountList',

  FILTERSEARCH_kubernetes_podListDetail_eventList:
    'FILTERSEARCH_kubernetes_podsListDetail_eventList',
  FILTERSEARCH_kubernetes_podListDetail_containerList:
    'FILTERSEARCH_kubernetes_podsListDetail_containerList',
  FILTERSEARCH_kubernetes_podListDetail_pvcList: 'FILTERSEARCH_kubernetes_podsListDetail_pvcList',

  FILTERSEARCH_kubernetes_namespaceDetail_podList:
    'FILTERSEARCH_kubernetes_namespaceDetail_podList',

  FILTERSEARCH_kubernetes_nodeDetail_eventList: 'FILTERSEARCH_kubernetes_nodeDetail_eventList',
  FILTERSEARCH_kubernetes_nodeDetail_podList: 'FILTERSEARCH_kubernetes_nodeDetail_podList',
  FILTERSEARCH_kubernetes_nodeDetail_processList: 'FILTERSEARCH_kubernetes_nodeDetail_processList',
  FILTERSEARCH_kubernetes_nodeDetail_diskList: 'FILTERSEARCH_kubernetes_nodeDetail_diskList',
  FILTERSEARCH_kubernetes_nodeDetail_imageList: 'FILTERSEARCH_kubernetes_nodeDetail_imageList',
  FILTERSEARCH_kubernetes_nodeDetail_gpuList: 'FILTERSEARCH_kubernetes_nodeDetail_gpuList',

  FILTERSEARCH_kubernetes_deploymentsDetail_eventList:
    'FILTERSEARCH_kubernetes_deploymentsDetail_eventList',
  FILTERSEARCH_kubernetes_deploymentsDetail_podList:
    'FILTERSEARCH_kubernetes_deploymentsDetail_podList',

  FILTERSEARCH_kubernetes_statefulSetsDetail_eventList:
    'FILTERSEARCH_kubernetes_statefulSetsDetail_eventList',
  FILTERSEARCH_kubernetes_statefulSetsDetail_podList:
    'FILTERSEARCH_kubernetes_statefulSetsDetail_podList',

  FILTERSEARCH_kubernetes_daemonSetsDetail_eventList:
    'FILTERSEARCH_kubernetes_daemonSetsDetail_eventList',
  FILTERSEARCH_kubernetes_daemonSetsDetail_podList:
    'FILTERSEARCH_kubernetes_daemonSetsDetail_podList',

  FILTERSEARCH_kubernetes_replicaSetsDetail_eventList:
    'FILTERSEARCH_kubernetes_replicaSetsDetail_eventList',
  FILTERSEARCH_kubernetes_replicaSetsDetail_podList:
    'FILTERSEARCH_kubernetes_replicaSetsDetail_podList',

  FILTERSEARCH_kubernetes_hpaDetail_eventList: 'FILTERSEARCH_kubernetes_hpaDetail_eventList',
  FILTERSEARCH_kubernetes_hpaDetail_podList: 'FILTERSEARCH_kubernetes_hpaDetail_podList',

  FILTERSEARCH_kubernetes_jobDetail_eventList: 'FILTERSEARCH_kubernetes_jobsDetail_eventList',
  FILTERSEARCH_kubernetes_jobDetail_podList: 'FILTERSEARCH_kubernetes_jobDetail_podList',

  FILTERSEARCH_kubernetes_cronJobsDetail_eventList:
    'FILTERSEARCH_kubernetes_cronJobsDetail_eventList',
  FILTERSEARCH_kubernetes_cronJobsDetail_jobList: 'FILTERSEARCH_kubernetes_cronJobsDetail_jobList',
  FILTERSEARCH_kubernetes_cronJobsDetail_podList: 'FILTERSEARCH_kubernetes_cronJobsDetail_podList',

  FILTERSEARCH_kubernetes_network_serviceDetail_eventList:
    'FILTERSEARCH_kubernetes_network_serviceDetail_eventList',
  FILTERSEARCH_kubernetes_network_serviceDetail_podList:
    'FILTERSEARCH_kubernetes_network_serviceDetail_podList',
  FILTERSEARCH_kubernetes_network_serviceDetail_endpointList:
    'FILTERSEARCH_kubernetes_network_serviceDetail_endpointList',
  FILTERSEARCH_kubernetes_network_ingressDetail_loadBalancerList:
    'FILTERSEARCH_kubernetes_network_ingressDetail_loadBalancerList',
  FILTERSEARCH_kubernetes_network_ingressDetail_eventList:
    'FILTERSEARCH_kubernetes_network_ingressDetail_eventList',
  FILTERSEARCH_kubernetes_network_openshiftRouteDetail_eventList:
    'FILTERSEARCH_kubernetes_network_openshiftRouteDetail_eventList',
  FILTERSEARCH_kubernetes_network_virtualServiceDetail_eventList:
    'FILTERSEARCH_kubernetes_network_virtualServiceDetail_eventList',
  FILTERSEARCH_kubernetes_network_virtualServiceDetail_routeList:
    'FILTERSEARCH_kubernetes_network_virtualServiceDetail_routeList',

  FILTERSEARCH_kubernetes_configStorage_configMapsDetail_eventList:
    'FILTERSEARCH_kubernetes_configStorage_configMapsDetail_eventList',
  FILTERSEARCH_kubernetes_configStorage_persistentVolumesClaimsDetail_eventList:
    'FILTERSEARCH_kubernetes_configStorage_persistentVolumesClaimsDetail_eventList',
  FILTERSEARCH_kubernetes_configStorage_persistentVolumesDetail_eventList:
    'FILTERSEARCH_kubernetes_configStorage_persistentVolumesDetail_eventList',
  FILTERSEARCH_kubernetes_configStorage_storageClassesDetail_eventList:
    'FILTERSEARCH_kubernetes_configStorage_storageClassesDetail_eventList',
  FILTERSEARCH_kubernetes_configStorage_storageClassesDetail_persistentVolumeList:
    'FILTERSEARCH_kubernetes_configStorage_storageClassesDetail_persistentVolumeList',

  FILTERSEARCH_kubernetes_accessControl_roleDetail_eventList:
    'FILTERSEARCH_kubernetes_accessControl_roleDetail_eventList',
  FILTERSEARCH_kubernetes_accessControl_roleBindingDetail_eventList:
    'FILTERSEARCH_kubernetes_accessControl_roleBindingDetail_eventList',
  FILTERSEARCH_kubernetes_accessControl_roleBindingDetail_referenceList:
    'FILTERSEARCH_kubernetes_accessControl_roleBindingDetail_referenceList',
  FILTERSEARCH_kubernetes_accessControl_roleBindingDetail_BindingList:
    'FILTERSEARCH_kubernetes_accessControl_roleBindingDetail_BindingList',
  FILTERSEARCH_kubernetes_accessControl_clusterRolesDetail_eventList:
    'FILTERSEARCH_kubernetes_accessControl_clusterRolesDetail_eventList',
  FILTERSEARCH_kubernetes_accessControl_clusterRoleBindingDetail_eventList:
    'FILTERSEARCH_kubernetes_accessControl_clusterRoleBindingDetail_eventList',
  FILTERSEARCH_kubernetes_accessControl_clusterRoleBindingDetail_referenceList:
    'FILTERSEARCH_kubernetes_accessControl_clusterRoleBindingDetail_referenceList',
  FILTERSEARCH_kubernetes_accessControl_clusterRoleBindingDetail_bindingList:
    'FILTERSEARCH_kubernetes_accessControl_clusterRoleBindingDetail_bindingList',
  FILTERSEARCH_kubernetes_accessControl_serviceAccountsDetail_eventList:
    'FILTERSEARCH_kubernetes_accessControl_serviceAccountsDetail_eventList',

  FILTERSEARCH_kubernetes_pvListDetail_persistentVolumeList:
    'FILTERSEARCH_kubernetes_pvListDetail_persistentVolumeList',
  FILTERSEARCH_kubernetes_nsListDetail_namespaceList:
    'FILTERSEARCH_kubernetes_nsListDetail_namespaceList',
  FILTERSEARCH_kubernetes_podListDetail_podList: 'FILTERSEARCH_kubernetes_podListDetail_podList',
  FILTERSEARCH_kubernetes_svListDetail_serviceList:
    'FILTERSEARCH_kubernetes_svListDetail_serviceList',
  FILTERSEARCH_kubernetes_ingressListDetail_ingressList:
    'FILTERSEARCH_kubernetes_ingressListDetail_ingressList',
  FILTERSEARCH_kubernetes_scListDetail_storageClassList:
    'FILTERSEARCH_kubernetes_scListDetail_storageClassList',
  FILTERSEARCH_kubernetes_pvcListDetail_persistentVolumeClaimList:
    'FILTERSEARCH_kubernetes_pvcListDetail_persistentVolumeClaimList',
  FILTERSEARCH_kubernetes_pvcListDetail_podList: 'FILTERSEARCH_kubernetes_pvcListDetail_podList',
  FILTERSEARCH_kubernetes_nodeListDetail_nodeList:
    'FILTERSEARCH_kubernetes_nodeListDetail_nodeList',

  FILTERSEARCH_kubernetes_storageOverview_distributionList:
    'FILTERSEARCH_kubernetes_storageOverview_distributionList',
  FILTERSEARCH_kubernetes_storageOverview_inventoryList:
    'FILTERSEARCH_kubernetes_storageOverview_inventoryList',
  FIELDS_kubernetes_storageOverview_inventoryList:
    'FIELDS_kubernetes_storageOverview_inventoryList',

  METRIC_kubernetes_podView_podDetail_metricChart:
    'METRIC_kubernetes_podView_podDetail_metricChart',
  METRIC_kubernetes_nodeView_nodeDetail_metricChart:
    'METRIC_kubernetes_nodeView_nodeDetail_metricChart',
  METRIC_kubernetes_namespaceView_namespaceDetail_metricChart:
    'METRIC_kubernetes_namespaceView_namespaceDetail_metricChart',
  METRIC_kubernetes_deploymentView_deploymentDetail_metricChart:
    'METRIC_kubernetes_deploymentView_deploymentDetail_metricChart',
  METRIC_kubernetes_statefulSetView_statefulSetDetail_metricChart:
    'METRIC_kubernetes_statefulSetView_statefulSetDetail_metricChart',
  METRIC_kubernetes_daemonSetView_daemonSetDetail_metricChart:
    'METRIC_kubernetes_daemonSetView_daemonSetDetail_metricChart',
  METRIC_kubernetes_hpaView_hpaDetail_metricChart:
    'METRIC_kubernetes_hpaView_hpaDetail_metricChart',
  METRIC_kubernetes_persistentVolumeClaimView_persistentVolumeClaimDetail_metricChart:
    'METRIC_kubernetes_persistentVolumeClaimView_persistentVolumeClaimDetail_metricChart',
  METRIC_kubernetes_serviceView_serviceDetail_metricChart:
    'METRIC_kubernetes_serviceView_serviceDetail_metricChart',
  METRIC_kubernetes_routeView_routeDetail_metricChart:
    'METRIC_kubernetes_routeView_routeDetail_metricChart',

  // 성능분석 > TrendAnalysis 하단(스위칭) 지표 — 분석 대상(kind)별 선택 지표 저장
  METRIC_kubernetes_trendAnalysis_bottomMetricByKind:
    'METRIC_kubernetes_trendAnalysis_bottomMetricByKind',

  // TrendAnalysis 하단 탭 그리드 — 컬럼설정(정렬/순서/가시성/폭) 저장 키
  GRIDCOLUMNS_kubernetes_trendAnalysis_podState: 'GRIDCOLUMNS_kubernetes_trendAnalysis_podState',
  GRIDCOLUMNS_kubernetes_trendAnalysis_process: 'GRIDCOLUMNS_kubernetes_trendAnalysis_process',
  GRIDCOLUMNS_kubernetes_trendAnalysis_rolloutCondition:
    'GRIDCOLUMNS_kubernetes_trendAnalysis_rolloutCondition',
  GRIDCOLUMNS_kubernetes_trendAnalysis_rolloutHistory:
    'GRIDCOLUMNS_kubernetes_trendAnalysis_rolloutHistory',
  GRIDCOLUMNS_kubernetes_trendAnalysis_pvc: 'GRIDCOLUMNS_kubernetes_trendAnalysis_pvc',
  GRIDCOLUMNS_kubernetes_trendAnalysis_scheduling:
    'GRIDCOLUMNS_kubernetes_trendAnalysis_scheduling',
  GRIDCOLUMNS_kubernetes_trendAnalysis_loadBalancing:
    'GRIDCOLUMNS_kubernetes_trendAnalysis_loadBalancing',
  GRIDCOLUMNS_kubernetes_trendAnalysis_event: 'GRIDCOLUMNS_kubernetes_trendAnalysis_event',
  GRIDCOLUMNS_kubernetes_trendAnalysis_log: 'GRIDCOLUMNS_kubernetes_trendAnalysis_log',
  // TrendAnalysis 하단 탭 그리드 — 토큰 검색필터 상태 저장 키
  FILTERSEARCH_kubernetes_trendAnalysis_podState: 'FILTERSEARCH_kubernetes_trendAnalysis_podState',
  FILTERSEARCH_kubernetes_trendAnalysis_process: 'FILTERSEARCH_kubernetes_trendAnalysis_process',
  FILTERSEARCH_kubernetes_trendAnalysis_rolloutCondition:
    'FILTERSEARCH_kubernetes_trendAnalysis_rolloutCondition',
  FILTERSEARCH_kubernetes_trendAnalysis_rolloutHistory:
    'FILTERSEARCH_kubernetes_trendAnalysis_rolloutHistory',
  FILTERSEARCH_kubernetes_trendAnalysis_pvc: 'FILTERSEARCH_kubernetes_trendAnalysis_pvc',
  FILTERSEARCH_kubernetes_trendAnalysis_scheduling:
    'FILTERSEARCH_kubernetes_trendAnalysis_scheduling',
  FILTERSEARCH_kubernetes_trendAnalysis_loadBalancing:
    'FILTERSEARCH_kubernetes_trendAnalysis_loadBalancing',
  FILTERSEARCH_kubernetes_trendAnalysis_event: 'FILTERSEARCH_kubernetes_trendAnalysis_event',
  FILTERSEARCH_kubernetes_trendAnalysis_log: 'FILTERSEARCH_kubernetes_trendAnalysis_log',

  METRIC_kubernetes_podView_podDetail_metricChart_timePeriod:
    'METRIC_kubernetes_podView_podDetail_metricChart_timePeriod',
  METRIC_kubernetes_nodeView_nodeDetail_metricChart_timePeriod:
    'METRIC_kubernetes_nodeView_nodeDetail_metricChart_timePeriod',
  METRIC_kubernetes_namespaceView_namespaceDetail_metricChart_timePeriod:
    'METRIC_kubernetes_namespaceView_namespaceDetail_metricChart_timePeriod',
  METRIC_kubernetes_deploymentView_deploymentDetail_metricChart_timePeriod:
    'METRIC_kubernetes_deploymentView_deploymentDetail_metricChart_timePeriod',
  METRIC_kubernetes_statefulSetView_statefulSetDetail_metricChart_timePeriod:
    'METRIC_kubernetes_statefulSetView_statefulSetDetail_metricChart_timePeriod',
  METRIC_kubernetes_daemonSetView_daemonSetDetail_metricChart_timePeriod:
    'METRIC_kubernetes_daemonSetView_daemonSetDetail_metricChart_timePeriod',
  METRIC_kubernetes_hpaView_hpaDetail_metricChart_timePeriod:
    'METRIC_kubernetes_hpaView_hpaDetail_metricChart_timePeriod',
  METRIC_kubernetes_persistentVolumeClaimView_persistentVolumeClaimDetail_metricChart_timePeriod:
    'METRIC_kubernetes_persistentVolumeClaimView_persistentVolumeClaimDetail_metricChart_timePeriod',
  METRIC_kubernetes_persistentVolumeView_persistentVolumeDetail_metricChart_timePeriod:
    'METRIC_kubernetes_persistentVolumeView_persistentVolumeDetail_metricChart_timePeriod',

  STAT_kubernetes_clusterView_statList: 'STAT_kubernetes_clusterView_statList',
  FIELDS_kubernetes_clusterResourceInventoryView_serviceWorkloadList:
    'FIELDS_kubernetes_clusterResourceInventoryView_serviceWorkloadList',

  TOGGLE_kubernetes_resourceInventoryDetail_service_info_expanded:
    'TOGGLE_kubernetes_resourceInventoryDetail_service_info_expanded',
  TOGGLE_kubernetes_resourceInventoryDetail_route_info_expanded:
    'TOGGLE_kubernetes_resourceInventoryDetail_route_info_expanded',
  TOGGLE_kubernetes_resourceInventoryDetail_ingress_info_expanded:
    'TOGGLE_kubernetes_resourceInventoryDetail_ingress_info_expanded',
  TOGGLE_kubernetes_resourceInventoryDetail_virtualService_info_expanded:
    'TOGGLE_kubernetes_resourceInventoryDetail_virtualService_info_expanded',
  TOGGLE_kubernetes_hpaDetail_info_expanded: 'TOGGLE_kubernetes_hpaDetail_info_expanded',
  TOGGLE_kubernetes_virtualServiceDetail_info_expanded:
    'TOGGLE_kubernetes_virtualServiceDetail_info_expanded',
  TOGGLE_kubernetesAnalysis_historyManagementDetail_podTimeline_expanded:
    'TOGGLE_kubernetesAnalysis_historyManagementDetail_podTimeline_expanded',
  TOGGLE_kubernetesAnalysis_historyManagementDetail_containerTimeline_expanded:
    'TOGGLE_kubernetesAnalysis_historyManagementDetail_containerTimeline_expanded',

  TOGGLE_kubernetes_podDetail_resourceStat_expanded:
    'TOGGLE_kubernetes_podDetail_resourceStat_expanded',
  TAB_kubernetes_replicaSetsDetail_selected: 'TAB_kubernetes_replicaSetsDetail_selected',
  TAB_kubernetes_hpaDetail_selected: 'TAB_kubernetes_hpaDetail_selected',
  TAB_kubernetes_deploymentsDetail_selected: 'TAB_kubernetes_deploymentsDetail_selected',
  TAB_kubernetes_daemonSetsDetail_selected: 'TAB_kubernetes_daemonSetsDetail_selected',
  TAB_kubernetes_statefulSetsDetail_selected: 'TAB_kubernetes_statefulSetsDetail_selected',
  TAB_kubernetes_cronJobsDetail_selected: 'TAB_kubernetes_cronJobsDetail_selected',
  TAB_kubernetes_jobsDetail_selected: 'TAB_kubernetes_jobsDetail_selected',
  TAB_kubernetes_configMapsDetail_selected: 'TAB_kubernetes_configMapsDetail_selected',
  TAB_kubernetes_clusterRolesDetail_selected: 'TAB_kubernetes_clusterRolesDetail_selected',
  TAB_kubernetes_clusterRolesBindingsDetail_selected:
    'TAB_kubernetes_clusterRolesBindingsDetail_selected',
  TAB_kubernetes_serviceAccountsDetail_selected: 'TAB_kubernetes_serviceAccountsDetail_selected',
  TAB_kubernetes_ingressDetail_selected: 'TAB_kubernetes_ingressDetail_selected',
  TAB_kubernetes_namespaceDetail_selected: 'TAB_kubernetes_namespaceDetail_selected',
  TAB_kubernetes_openshiftRouteDetail_selected: 'TAB_kubernetes_openshiftRouteDetail_selected',
  TAB_kubernetes_virtualServiceDetail_selected: 'TAB_kubernetes_virtualServiceDetail_selected',
  TAB_kubernetes_rolesDetail_selected: 'TAB_kubernetes_rolesDetail_selected',
  TAB_kubernetes_rolesBindingsDetail_selected: 'TAB_kubernetes_rolesBindingsDetail_selected',
  TAB_kubernetes_serviceDetail_selected: 'TAB_kubernetes_serviceDetail_selected',
  TAB_kubernetes_nodeDetail_selected: 'TAB_kubernetes_nodeDetail_selected',
  TAB_kubernetes_persistentVolumesDetail_selected:
    'TAB_kubernetes_persistentVolumesDetail_selected',
  TAB_kubernetes_storageClassesDetail_selected: 'TAB_kubernetes_storageClassesDetail_selected',
  TAB_kubernetes_podsListDetail_selected: 'TAB_kubernetes_podsListDetail_selected',
  TAB_kubernetes_persistentVolumesClaimsDetail_selected:
    'TAB_kubernetes_persistentVolumesClaimsDetail_selected',
  TAB_kubernetesAnalysis_eventDetail_selected: 'TAB_kubernetesAnalysis_eventDetail_selected',
  TAB_kubernetesAnalysis_historyManagementDetail_selected:
    'TAB_kubernetesAnalysis_historyManagementDetail_selected',
};
